import { SEGMENT_TO_DISPLAY_NAME_MAP } from 'modules/Ordering';
import SearchService from 'modules/Search';

export const getScripsForSurveillanceEvent = async (
  instrumentKeys: string[],
): Promise<Record<string, string[]> | null> => {
  const scripsMap: Record<string, string[]> = {};
  try {
    await Promise.all(instrumentKeys.map(async (instrumentKey) => {
      const scrip = await SearchService.searchByInstrumentKey(instrumentKey);
      const segmentDisplayName = scrip?.exchange
        ? SEGMENT_TO_DISPLAY_NAME_MAP[scrip.segment]
        : scrip?.exchange;
      const scripSymbol = scrip?.symbol;
      if (segmentDisplayName && scripSymbol) {
        if (scripsMap[segmentDisplayName]) {
          scripsMap[segmentDisplayName].push(scripSymbol);
        } else {
          scripsMap[segmentDisplayName] = [scripSymbol];
        }
      }
    }));
    return scripsMap;
  } catch (error) {
    return null;
  }
};
